import { genesisIcons } from '@formkit/icons';
import { rootClasses } from './formkit.theme.js';
import { createMultiStepPlugin } from '@formkit/addons';

const multiStepPlugin = createMultiStepPlugin({
  tabStyle: 'progress',
  allowIncomplete: false
});

export default {
  plugins: [ multiStepPlugin ],
  icons: {
    ...genesisIcons
  },
  config: {
    rootClasses
  }
};
